import React from "react"


const QuestionsSliderFooter = ({dots}) => (
    <div className="jm-slider-footer">
        <div className="jm-slide-dotswrapper">
            <ul className="jm-slide-dots">{dots}</ul>
        </div>
    </div>
)


export default QuestionsSliderFooter